/**
 * 路由配置
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-08 11:17:18
 * @LastEditTime: 2021-04-14 09:35:14
 * @FilePath: \buyer-one\dop-webapp\config\routes.js
 * @Copyright: Copyright 2021-2021 ESSA. all rights reserved.
 */
import Index from "@pages/Index/Index/index";
import TransactionDataRouter from "@pages/TransactionData/TransactionDataRouter";
// <<<<<<< HEAD
// import Customer from "@pages/Customer/Index/Index";
import GoodsSkuNameMgr from "@pages/Goods/SkuNameMgr";
import CertificateMgr from "@pages/Goods/CertificateMgr";
import CertificateAttachmentRule from "@pages/Goods/CertificateAttachment/attachmentRule";
// import InfringementConfirmationList from "@pages/CustomsDeclarationStickerManagement/InfringementConfirmation/List"; //侵权确认列表
// =======
// >>>>>>> remotes/origin/master
import User from "@pages/User/Index";
import DataStatisticsRouter from "@pages/DataStatistics/DataStatisticsRouter";

// import PoDetail from "@pages/Po/PoDetail/index";

import FinanceRouter from "@pages/FinanceManagement/FinanceRouter";

import AfterSaleRouter from "@pages/AfterSale/AfterSaleRouter";

import InventoryQuery from "@pages/InventoryQuery/InventoryQuery";
import DistributorRouter from "@pages/DistributorManagement/DistributorRouter";

import CustomerRouter from "@pages/Customer/CustomerRouter"; // 客户管理
// 报送贴纸管理
import CustomsDeclarationStickerRouter from "@pages/CustomsDeclarationStickerManagement/CustomsDeclarationStickerRouter";
// 出货单管理
import ShipperRouter from "@pages/ShipperManagement/ShipperRouter";
// 订单管理
import OrderRouter from "@pages/OrderManagement/OrderRouter";
//仓库管理
import WarehouseRouter from "@pages/WarehouseManagement/WarehouseRouter";
// 商品管理
import GoodsRouter from "@pages/Goods/GoodsRouter";

import ShipmentOrderRouter from "@pages/ShipmentOrder/ShipmentOrderRouter";
//  客户取消记录 管理
import CancelRecordRouter from "@pages/CancelRecord/CancelRecordRouter";
import MyToDoList from "@pages/Index/MyToDoList";
import DopIndex from "@pages/Index/dopIndex";
import FinToDoList from "@pages/Index/FinToDoList";
export let routes = [
    {
        path: "/index",
        //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
        lang: {
            key: "ShouYe",
            default: "首页"
        },
        routes: [
            {
                path: "/index/count",
                component: Index,
                //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
                lang: {
                    key: "ShouYe",
                    default: "首页"
                },

            }
        ]
    },

    {
        path: "/transactionData",
        //改为统一使用后端返回的字段（icon） icon: "icon-shouhousuopei",
        lang: {
            key: "PingTaiJiaoYiShuJu",
            default: "平台交易数据"
        },
        component: TransactionDataRouter,
    },

    {
        path: "/customer",
        //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
        lang: {
            key: "KeHuGuanLi",
            default: "客户管理"
        },
        component: CustomerRouter,
    },
    {
        path: "/goods",
        //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
        lang: {
            key: "ShangPinGuanLi",
            default: "商品管理"
        },

        routes: [
            {
                path: "/goods/sku-name-mgr",
                component: GoodsSkuNameMgr,
                //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
                lang: {
                    key: "SKUPinMing",
                    default: "商品品名"
                },

            },
            {
                path: "/goods/certificate-mgr",
                component: CertificateMgr,
                //改为统一使用后端返回的字段（icon） icon: "icon-kehuxinxi",
                lang: {
                    key: "ZhengShuGuanLi",
                    default: "证书管理"
                },

            },
            {
                path: "/goods/certificate-attachment-rule",
                component: CertificateAttachmentRule,
                lang: {
                    key: "ZhengShuGuaKao",
                    default: "证书挂靠"
                },

            },

        ],
        component: GoodsRouter,

    },
    {
        path: "/warehouseManagement",
        hasChildren: true,
        //改为统一使用后端返回的字段（icon） icon: "icon-cangkuguanli",
        lang: {
            key: "",
            default: "仓库管理"
        },
        component: WarehouseRouter,

    },
    {
        path: "/cancelRecord",
        //改为统一使用后端返回的字段（icon） icon: "icon-quxiaodengji",
        lang: {
            key: "KeHuQuXiaoJiLu",
            default: "客户取消记录"
        },
        component: CancelRecordRouter,
    },
    {
        path: "/shipmentOrder",
        // component: ShipmentOrder,
        //改为统一使用后端返回的字段（icon） icon: "icon-chuhuodan",
        lang: {
            key: "chuHuoDan",
            default: "出货单"
        },
        component: ShipmentOrderRouter,
    },
    {
        path: "/afterSale",
        //改为统一使用后端返回的字段（icon） icon: "icon-shouhousuopei",
        lang: {
            key: "shouHouSuoPei",
            default: "售后索赔"
        },
        component: AfterSaleRouter,
    },
    {
        path: "/financeManagement",
        hasChildren: true,
        //改为统一使用后端返回的字段（icon） icon: "icon-caiwuguanli",
        lang: {
            key: "",
            default: "财务管理"
        },
        component: FinanceRouter
    },
    {
        path: "/distributor",
        icon: "icon-tuiguangxiangqing",
        code:"FenXiaoShangGuanLi",
        name:"分销管理",
        component: DistributorRouter
    },
    {
        path: "/user",
        component: User,
        //改为统一使用后端返回的字段（icon） icon: "icon-zhanghaoguanli",
        lang: {
            key: "YuanGongZhangHaoGuanLi",
            default: "账号管理"
        }
    },
    {
        path: "/dataStatistics",
        hasChildren: true,
        lang: {
            key: "ShuJuTongJi",
            default: "数据统计"
        },
        component: DataStatisticsRouter,
    },
    {
        path: "/inventoryQuery",
        component: InventoryQuery,
        lang: {
            key: "KuCunChaXun",
            default: "库存查询"
        }
    },
    {
        path: "/customsDeclarationSticker",
        hasChildren: true,
        icon: "icon-caiwuguanli",
        code:"BaoGuanTieZhiGuanLi",
        name:"报关贴纸管理",
        component: CustomsDeclarationStickerRouter
    },
    {
        path: "/shipperManagement",
        hasChildren: true,
        icon: "icon-chuhuodanguanli",
        code:"ChuHuoDanGuanLi",
        name:"出货单管理",
        component: ShipperRouter
    },
    {
        path: "/order",
        hasChildren: true,
        icon: "icon-caiwuguanli",
        code:"DingDanGuanLi",
        name:"订单管理",
        component: OrderRouter
    },
    {
        path: "/myToDoList", //首页建议放最后
        lang: {
            key: "WoDeDaiBan",
            default: "我的待办"
        },
        component: MyToDoList,
    },
    {
        path: "/finToDoList", //财务工作台
        lang: {
            key: "CaiWuDaiBan",
            default: "财务待办"
        },
        component:FinToDoList,
    },
    {
        path: "/", //首页建议放最后
        lang: {
            key: "ShouYe",
            default: "首页"
        },
        component: DopIndex,
    },
];
